<template>
  <div class="ontos-base pa-0">
    <!-- Por cima do conteúdo, e não antes dele: ocupando a própria linha, a barra empurrava a tela
         4px para baixo enquanto carregava, e ao sumir a tela inteira dava um tranco para cima. E
         some apagando, em vez de num quadro. -->
    <v-fade-transition>
      <v-progress-linear v-if="loading" indeterminate absolute location="top"/>
    </v-fade-transition>
    <!-- align/justify: o v-overlay do Vuetify 4 não centraliza o conteúdo sozinho, e o
         indicador ia parar no canto superior esquerdo da janela. -->
    <v-overlay :model-value="saving" class="align-center justify-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- O padding do container é a folga da PÁGINA. Uma tela embutida em outra já está
         dentro da folga de quem a hospeda, e somar as duas a desalinharia do conteúdo
         vizinho — foi o que deslocou o quadro do relacionamento 16px para dentro, dele e das
         raias, dentro do bloco da ficha. -->
    <v-container ref="container" fluid :class="{'pa-0': flush, 'pa-0 pa-sm-4': phoneFlush && !flush}">
      <slot/>
    </v-container>
  </div>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import {revealOnArrival} from '@/utils/motion'

@Component
class Base extends Vue {
  @Prop({type: Boolean}) readonly saving!: boolean
  @Prop({type: Boolean}) readonly loading!: boolean
  /** Sem a folga da página: para quando esta tela é desenhada dentro de outra. */
  @Prop({type: Boolean}) readonly flush!: boolean
  /**
   * Sem a folga da página só no telefone (`xs`): para a tela cuja superfície já traz o próprio
   * respiro e lá vai de borda a borda — a ficha e o formulário do item (ver `InstanceCard`). Somadas,
   * as duas folgas comiam a largura que falta no telefone. Do `sm` para cima, os 16px de sempre.
   */
  @Prop({type: Boolean}) readonly phoneFlush!: boolean

  name = 'ontos-base'

  private stopRevealing: (() => void) | null = null

  /**
   * O conteúdo acende quando chega, em vez de aparecer num quadro só — toda tela carrega
   * por aqui, e por isso é aqui que mora. Ver o `revealOnArrival`.
   */
  mounted() {
    this.stopRevealing = revealOnArrival((this.$refs.container as any).$el)
  }

  beforeUnmount() {
    this.stopRevealing?.()
  }
}

export default toNative(Base)
</script>

<style scoped>
/* A régua do `absolute` da barra de progresso */
.ontos-base {
  position: relative;
}
</style>
